export enum NewsletterSubscriptionEndpoint {
  Confirm = '/action/email/confirm',
  Subscribe = '/profile/newsletter/subscribe',
  Unsubscribe = '/action/newsletter/unsubscribe',
}
